import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { AddOn } from '../../types/pricing';
type AddOnsProps = {
  items: AddOn[];
};
export function AddOns({
  items
}: AddOnsProps) {
  return <section className="w-full bg-canvas-warm py-20" aria-labelledby="addons-heading" data-id="element-910" data-mp="15mej3n2fe1qo">
      <div className="mx-auto max-w-shell px-6" data-id="element-911" data-mp="10o39ndg1lt8z">
        <h2 id="addons-heading" className="display text-[30px] font-semibold text-ink sm:text-[36px]" data-id="element-912" data-mp="10nabv1z2ae2z">
          Add-ons
        </h2>
        <p className="mt-3 max-w-[520px] text-[16px] leading-[1.5] text-ink-muted" data-id="element-913" data-mp="rn54usxs5hpc">
          Extend any plan as your business grows.
        </p>
        <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-914" data-mp="mp3q2k7e04jo">
          {items.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex h-full flex-col rounded-[14px] bg-white p-6" data-id="element-915" data-mp="2h2lba0kbkpbj">
                <span className="flex h-10 w-10 items-center justify-center rounded-[9px] border border-canvas-line text-ink" data-id="element-916" data-mp="2c2gyolmj8eql">
                  <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-917" data-mp="36g4g6rlvstfh" />
                </span>
                <h3 className="mt-5 text-[16px] font-semibold tracking-[-0.01em] text-ink" data-id="element-918" data-mp="3bhblmk0jxgiz">{item.title}</h3>
                <p className="mt-2 text-[14px] leading-[1.5] text-ink-muted" data-id="element-919" data-mp="2wkuc7ybxabz2">{item.copy}</p>
                <a href="#" className="group mt-auto inline-flex items-center gap-1.5 pt-5 text-[14px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-920" data-mp="31i2udyx2mg0b">
                  Contact us
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-921" data-mp="3fgu5rdkjtnkr" />
                </a>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}